__turbopack_context__.v({
  "className": "sora_68130bc6-module__DxAtGW__className",
});
